module.exports = __webpack_public_path__ + "static/guest-experts.a62867b2.png";